<template>
  <div>
    <header></header>
    <div id="container">
      <div class="box">
        <div class="title">
          <h1>管理后台登录</h1>
        </div>

        <div class="main">
          <form>
            <!-- <group-select @groupSelect="getGroup"></group-select><br/> -->

            <input type="text" placeholder="登录账号" v-model="info.account"><br/>

            <input type="password" placeholder="登录密码" v-model="info.pwd">

            <div v-show="verifyCode">  
              <input type="text" style="width:150px;" placeholder="验证码" v-model="info.code_value">
              <img :src="verifyCode" @click="getVerifyCode"/>
            </div>

            <el-alert :title="msg" type="error" v-show="show"></el-alert>

            <div style="width:320px;height:12px;margin:3px auto;text-align:left;">
              <input type="checkbox"  v-model="rememberPwd" style="margin:3px;width:14px;height:14px;float:left;" /> 
              <span style="font-size:14px;float:left;">记住密码</span>
              <div class="clear"></div>
            </div>
            <a class="submit" href="javascript:void(0)" @click="login">登 录</a>
          </form>
        </div>
      </div>
    </div>
    <footer>
      <p>

        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery " target="_blank" style="color:">粤ICP备19052100号</a> COPYRIGTH © 2018<br />
        powered by：www.nooie.cn
      </p>
      <div class="linkOther">
        <span>友情链接：</span>
        <a v-for="(host, key) in hosts" :href="host.url" :key="key" :class="host.url == nowHost ? 'active' : ''">{{ host.name }}</a>
      </div>
    </footer>
  </div>
</template>

<style scoped>
@import "../../assets/login.css";
.el-alert__content {
  margin: 0px auto;
}
.el-alert {
  width: 322px;
  margin: 0px auto;
}
</style>

<script>
/* eslint-disable */
// import groupSelect from '../../components/form/groupSelect.vue'

export default {
  name: 'login',
  components: {
    // 'group-select': groupSelect
  },
  data () {
    return {
      info: {
        // role: 0,
        account: '',
        pwd: '',
        code_id: '',
        code_value: ''
      },
      verifyCode: "", 
      show: false,
      msg: '',
      redirect: 'user',
      hosts: {},
      nowHost: '',
      rememberPwd: true
    }
  },
  mounted () {
    this.nowHost = window.location.host
    this.host()
    this.getVerifyCode()

    if (this.$store.state.login.isLogin)
      location.href = this.$store.state.login.menus[0].route

    if (localStorage.loginInfo)
      this.info = JSON.parse(localStorage.loginInfo)

    var redirect = this.$route.params.redirect

    if (this.$route.params.redirect)
      this.redirect = redirect

    document.title = "后台登录"
  },
  methods: {
    getGroup: function (role) {
      this.info.role = role
    },
    remember: function () {
      this.rememberPwd = !this.rememberPwd
      console.log(this.rememberPwd)
    },
    getVerifyCode: function () {
        this.api.adminVerifyCode({"width":"100", "height":"48"}).then(res => {
          var data = res.data.data
          this.verifyCode = data.bs64
          this.info.code_id = data.id
          console.log(this.verifyCode, this.info)
        }).catch(err => {
          console.log('请求失败：', err)
        })
    },
    login: function () {
      this.show = false

      // if (!this.info.role) {
      // 	this.show = true
      // 	this.msg = '请选择角色'
      // 	return false
      // }

      if (!this.info.account.length) {
        this.show = true
        this.msg = '请输入账号'
        return false
      }

      if (!this.info.pwd.length) {
        this.show = true
        this.msg = '请输入密码'
        return false
      }

      if (!this.info.code_value) {
        this.show = true
        this.msg = '请输入验证码'
        return false
      }

      var info = {
        "account":this.info.account, "password":this.$md5(this.info.pwd), 
        "code_id": this.info.code_id, "code_value": this.info.code_value
      }
      this.api.adminLogin(info).then(res => {
        if (res.data.code == 200) {
          var cache = {"account":this.info.account, "name": res.data.data.user, "appid": res.data.data.appid}
          if (this.rememberPwd) cache.pwd = this.info.pwd
          localStorage.setItem("loginInfo", JSON.stringify(cache))

          var adminer = {
            "uid": res.data.data.uid,
            "token": res.data.data.token,
            "region": res.data.data.region
            // "role": res.data.data.role
          }

          localStorage.setItem("appid", res.data.data.appid)
          localStorage.setItem("isLogin", true)
          localStorage.setItem("adminer", JSON.stringify(adminer))
          localStorage.setItem("menus", JSON.stringify(res.data.data.menu))
          localStorage.setItem("funs", JSON.stringify(res.data.data.fun))
          localStorage.setItem("role", res.data.data.roles[0])

          // console.log(localStorage)
          // return false

          location.href = res.data.data.menu[0].route
        } else {
          this.show = true
          this.msg = res.data.msg
          this.getVerifyCode()
        }
      }).catch(err => {
        console.log('请求失败：', err)
      })
    },
    host: function () {
      this.api.linkList().then(res => {
        if (res.data.code == 200) {
          this.hosts = res.data.data
        } else {
          console.error(res.data.msg)
        }
      }).catch(err => {
        console.log('请求失败：', err)
      })
    }
  },
  created () {
    let that = this
    document.onkeydown = function (e) {
      var key = window.event.keyCode
      if (key === 13) that.login()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/pageLogin.vue